"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestraHistoria() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tenets = [{
    index: "01",
    declaration: "Calidad certificada en cada proceso de fundición."
  }, {
    index: "02",
    declaration: "Compromiso inquebrantable con la sostenibilidad ambiental."
  }, {
    index: "03",
    declaration: "Innovación tecnológica para la industria del acero."
  }, {
    index: "04",
    declaration: "Relaciones sólidas basadas en la integridad y confianza."
  }];
  return <section data-section-id="2008" id="nuestra-historia" className="bg-background text-foreground py-32 md:py-44 px-6 md:px-12 lg:px-16 overflow-hidden">
      <div className="max-w-[1480px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div ref={leftRef} className={`lg:col-span-6 relative transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div aria-hidden="true" className="pointer-events-none absolute -top-8 -left-4 select-none font-default font-black leading-none" style={{
            fontSize: "clamp(12rem, 22vw, 22rem)",
            color: "transparent",
            WebkitTextStroke: "1px var(--primary)",
            opacity: 0.08,
            letterSpacing: "-0.04em"
          }}>
              KA
            </div>

            {}
            <div className="relative font-mono uppercase mb-10" style={{
            letterSpacing: "0.18em",
            fontSize: "clamp(0.6875rem, 0.8vw, 0.8125rem)"
          }}>
              <span className="text-accent">§ 00 — KALISCH ACERO / MANIFIESTO</span>
            </div>

            {}
            <h1 className="relative font-default font-bold text-primary" style={{
            fontSize: "clamp(3.25rem, 8vw, 7.5rem)",
            lineHeight: 0.88,
            letterSpacing: "-0.04em"
          }}>
              Forjamos el{" "}
              <span className="font-default italic font-normal text-secondary">
                futuro
              </span>{" "}
              del acero.
            </h1>

            {}
            <div className="relative mt-12 mb-10 flex items-center">
              <div className="flex-1 h-px bg-border" />
              <div className="w-1.5 h-1.5 ml-0 bg-accent" />
            </div>

            {}
            <p className="font-default relative text-muted-foreground" style={{
            fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
            lineHeight: 1.55
          }}>
              Kalisch Acero no es solo un proveedor de materiales. Somos un pilar estratégico en la cadena de suministro industrial, dedicados a la transformación y distribución de acero con los más altos estándares de excelencia. Nuestra historia se escribe con la fuerza del metal y la visión de un México más fuerte. No solo entregamos productos; entregamos la base sólida sobre la cual se construyen los grandes proyectos de infraestructura y desarrollo nacional.
            </p>

            {}
            <div className="relative mt-14">
              {tenets.map((tenet, i) => <div key={tenet.index} data-index={i} className={`transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: leftVisible ? `${200 + i * 80}ms` : "0ms"
            }}>
                  <div className="flex items-center pt-5 pb-5">
                    <div className="font-mono shrink-0 w-16 md:w-20 text-primary" style={{
                  fontSize: "clamp(0.6875rem, 0.8vw, 0.8125rem)",
                  letterSpacing: "0.18em"
                }}>
                      {tenet.index} —
                    </div>
                    <div className="font-default italic font-semibold text-foreground" style={{
                  fontSize: "clamp(1.0625rem, 1.4vw, 1.375rem)",
                  lineHeight: 1.3
                }}>
                      {tenet.declaration}
                    </div>
                  </div>
                  {}
                  <div className="flex items-center">
                    <div className="flex-1 h-px bg-border" />
                    <div className="w-1.5 h-1.5 bg-primary" />
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-6 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: rightVisible ? "150ms" : "0ms"
        }}>
            <div className="relative w-full h-full min-h-[480px] lg:min-h-[720px]">
              {}
              <div className="relative w-full h-full aspect-[4/5] lg:aspect-auto lg:absolute lg:inset-0 overflow-hidden rounded-lg shadow-xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/planta_procesamiento_acero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/planta_procesamiento_acero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/planta_procesamiento_acero.png-wvc-sizes" alt="Operario especializado supervisando el proceso de fundición en la planta de Kalisch Acero" loading="lazy" decoding="async" className="w-full h-full object-cover" style={{
                filter: "saturate(0.8) contrast(1.05) brightness(0.9)"
              }} />

                {}
                <div className="absolute top-4 left-4 w-3 h-3 pointer-events-none">
                  <div className="absolute top-0 left-0 w-full h-px bg-accent" />
                  <div className="absolute top-0 left-0 h-full w-px bg-accent" />
                </div>
                {}
                <div className="absolute top-4 right-4 w-3 h-3 pointer-events-none">
                  <div className="absolute top-0 right-0 w-full h-px bg-accent" />
                  <div className="absolute top-0 right-0 h-full w-px bg-accent" />
                </div>
                {}
                <div className="absolute bottom-4 left-4 w-3 h-3 pointer-events-none">
                  <div className="absolute bottom-0 left-0 w-full h-px bg-accent" />
                  <div className="absolute bottom-0 left-0 h-full w-px bg-accent" />
                </div>
                {}
                <div className="absolute bottom-4 right-4 w-3 h-3 pointer-events-none">
                  <div className="absolute bottom-0 right-0 w-full h-px bg-accent" />
                  <div className="absolute bottom-0 right-0 h-full w-px bg-accent" />
                </div>

                {}
                <div className="absolute bottom-0 left-0 right-0 px-6 py-4 font-mono uppercase backdrop-blur-md" style={{
                backgroundColor: "hsl(var(--primary) / 0.9)",
                color: "white",
                fontSize: "0.75rem",
                letterSpacing: "0.18em",
                borderTop: "1px solid var(--accent)"
              }}>
                  FIG. 01 — INFRAESTRUCTURA / PLANTA INDUSTRIAL / CHIHUAHUA
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}